import * as React from 'react'
import { useEffect, useState, useMemo } from 'react'
import { getObjectsWithFilter } from '../../../api/apiClientCrud'
import { toast } from 'react-toastify'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import { getContractColumns } from './ContractFields'
import DocumentPreview from '../../document/DocumentPreview'
import Contract from './Contract'
import Loading from '../../common/Loading'
import { Box } from '@mui/material'

const ListContract = () => {
  const [statusList, setStatusList] = useState([])
  const [customers, setCustomers] = useState([])
  const { user } = useAuth()
  const userRight = useOutletContext()

  useEffect(() => {
    const loadData = async () => {
      try {
        const [statusListRes, customersRes] = await Promise.all([
          getObjectsWithFilter('status', { object: 'contracts' }),
          getObjectsWithFilter('customers', { company_id: user.company_id })
        ])
        setStatusList(Array.isArray(statusListRes.data) ? statusListRes.data : [])
        setCustomers(Array.isArray(customersRes.data?.customers) ? customersRes.data.customers : [])
      } catch (error) {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      }
    }

    loadData()
  }, [user.company_id])

  const columns = useMemo(() => {
    if (!statusList.length || !customers.length) return []
    return getContractColumns({ statusList, customers })
  }, [statusList, customers])

  const options = useMemo(
    () => ({
      objectType: 'contracts',
      accessRight: userRight,
      objectFilter: () => {
        return { owner_id: 1 }
      },
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer le contrat',
          field: 'contract_number'
        }
      },
      isFilter: true,
      isExpand: true,
      defaultSorted: 'contract_number',
      expand: (row) => <DocumentPreview Component={Contract} document={row} />,
      columns
    }),
    [userRight, user.company_id, columns]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'contracts',
      title: 'Contrats',
      accessRight: userRight,
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )
  if (!columns.length)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )

  return <ListModule options={options} toolbar={toolbar} />
}

export default ListContract
